.toolbar {
  display: flex;
  flex-direction: row;
  gap: 0;
  align-items: center;
  margin-left: 0.5rem;
}

pos-navigation {
  flex-grow: 1;
}
